import { useEffect, useRef, useState } from "react";
import { Smiley } from "@phosphor-icons/react";

const GROUPS = [
  { l: "Česti", e: "😊 😀 😃 😄 😁 😉 🙂 😍 🥰 😘 🤗 😎 🤩 🥳 😅 😂 🤣 😇 🙏 👍 👌 👏 🙌 💪 ✌️ 🤞 👋 ❤️ 💙 💚 🧡 💛 ✨ 🎉 ✅ ⭐" },
  { l: "Osjećaji", e: "😌 😴 🤔 😮 😯 😲 😢 😭 😔 😕 🙁 😬 😳 🤭 🤫 🙃 😏 😐 😑 😷 🤒 🥺 😤 😡" },
  { l: "Smještaj", e: "🏠 🏡 🏢 🏨 🛏️ 🛁 🚿 🧺 🧴 🧼 🔑 🗝️ 🚪 🪟 🛋️ 🍳 ☕ 🍽️ 🍷 🍾 🧊 📶 🅿️ 🚗 🚕 🚌 ✈️ 🛳️ 🧳" },
  { l: "More i grad", e: "☀️ 🌤️ ⛅ 🌧️ 🌊 🏖️ 🏝️ ⛱️ 🐚 🐟 🍦 🍕 🍝 🥗 🍤 🍋 🌴 🌸 🌅 🌇 🗺️ 📍 ⏰ 🕒 📅 📞 💬 📧 💶 💳" },
];

export function EmojiPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  return (
    <div className="relative self-stretch" ref={ref}>
      <button type="button" onClick={() => setOpen((v) => !v)} className={`flex h-full items-center rounded-md border border-border px-2.5 text-muted-foreground hover:bg-muted hover:text-foreground ${open ? "bg-muted text-foreground" : ""}`} title="Emoji" data-testid="emoji-picker-btn">
        <Smiley size={18} />
      </button>
      {open && (
        <div className="rw-pop absolute bottom-full right-0 z-50 mb-2 w-[300px] max-w-[calc(100vw-24px)] rounded-lg border border-border bg-popover p-2 shadow-xl" data-testid="emoji-picker">
          <div className="max-h-64 overflow-y-auto">
            {GROUPS.map((g) => (
              <div key={g.l} className="mb-1.5">
                <p className="px-1 pb-0.5 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">{g.l}</p>
                <div className="grid grid-cols-8 gap-0.5">
                  {g.e.split(" ").map((em) => (
                    <button key={em} type="button" onClick={() => onPick(em)} className="rounded p-1 text-lg leading-none transition-transform hover:scale-125 hover:bg-muted" data-testid="emoji-option">{em}</button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
